var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoPicto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 48,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4dc76df8e4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 127.199219 127.199219 L 622.949219 127.199219 L 622.949219 622.949219 L 127.199219 622.949219 Z M 127.199219 127.199219 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4dc76df8e4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#31929e",
    d: "M 375.042969 127.199219 C 511.917969 127.199219 622.886719 238.167969 622.886719 375.042969 C 622.886719 511.917969 511.917969 622.886719 375.042969 622.886719 C 238.167969 622.886719 127.199219 511.917969 127.199219 375.042969 C 127.199219 238.167969 238.167969 127.199219 375.042969 127.199219 Z M 405.179688 214.839844 C 423.859375 214.839844 439.007812 229.988281 439.007812 248.667969 C 439.007812 267.371094 423.859375 282.523438 405.179688 282.523438 C 386.496094 282.523438 371.324219 267.371094 371.324219 248.667969 C 371.324219 229.988281 386.472656 214.839844 405.179688 214.839844 Z M 312.679688 341.097656 C 334.542969 296.859375 427.691406 282.5 411.101562 343.09375 C 401.625 377.714844 376.507812 469.5625 372.601562 484.964844 C 367.769531 504.042969 389.632812 505.066406 413.054688 494.632812 C 393.144531 546.003906 292.582031 554.230469 314.074219 486.246094 C 314.074219 486.246094 342.5625 382.410156 350.34375 358.894531 C 358.964844 332.824219 329.617188 332.5 312.679688 341.074219 Z M 375.066406 150.640625 C 251.132812 150.640625 150.6875 251.109375 150.6875 375.019531 C 150.6875 498.953125 251.15625 599.398438 375.066406 599.398438 C 499 599.398438 599.445312 498.929688 599.445312 375.019531 C 599.445312 251.085938 498.976562 150.640625 375.066406 150.640625 Z M 375.066406 150.640625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPicto);
export default __webpack_public_path__ + "static/media/info_picto.4e92495989e999c1026e70f8e53e0612.svg";
export { ForwardRef as ReactComponent };